import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Popover } from 'primeng/popover';
import { TranslocoService } from '@jsverse/transloco';
import { User } from '../../../core/models/common/user.model';
import { EmailLauncherService } from '../../../core/services/email-launcher.service';
import { CurrentPlan } from '../../../core/models/corporate/current-plan.model';

@Component({
  selector: 'app-quick-menu',
  standalone: false,
  templateUrl: './quick-menu.component.html',
  styleUrl: './quick-menu.component.scss'
})
export class QuickMenuComponent {

  @ViewChild('overlay') overlay!: Popover;
  @Input() user: User | null = null;

  @Input() currentPlan: CurrentPlan | null = null;

  constructor(
    private router: Router,
    private emailLauncher: EmailLauncherService,
    private transloco: TranslocoService
  ) {
  }

  openPanel(event: MouseEvent, button: HTMLElement) {
    this.overlay.toggle(event);
    setTimeout(() => {
      if (this.overlay.container && button instanceof HTMLElement) {
        const buttonRect = button.getBoundingClientRect();
        const left = buttonRect.right + 20;
        const top = buttonRect.top;

        Object.assign(this.overlay.container.style, {
          position: 'fixed',
          left: `${left}px`,
          top: `${top}px`,
          right: 'auto',
          margin: '0',
        });
        this.overlay.container.style.visibility = 'visible';
      }
    }, 0);
  }

  goTo(path: string) {
    if (path === 'profile') {
      this.router.navigate(['/dashboard', path]);
      return;
    } else {
      this.router.navigate(['/dashboard', 'profile', path]);
    }
    this.overlay.hide();
  }

  logout() {
    localStorage.removeItem('token');
    this.router.navigate(['/auth', 'login']);
  }
  openHelpEmail() {
    this.emailLauncher.openEmail(
      'servicioalcliente@pitts.app',
      this.transloco.translate('quickMenu.helpEmailSubject'),
      this.transloco.translate('quickMenu.helpEmailBody')
    );
  }
}